import React from 'react'
import './Image.scss'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Image = ({image, caption}) => {
	return(
		<div className="CaseContent-Image">
			<div className="grid">
				<div className="image">
					{
						image &&
						<GatsbyImage image={getImage(image.localFile.childImageSharp)} alt={image.altText} />
					}
					{
						caption &&
						<p className="caption">{caption}</p>
					}
				</div>
			</div>
		</div>
	)
}

export default Image